<template>
    <v-speed-dial
      v-if="isMobile"
      style="position:fixed;z-index:100;"
      v-model="fab"
      top
      left
      direction="bottom"
      :open-on-hover="false"
      transition="slide-y-reverse-transition"
      x-small
      elevation="1"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          :color="enterpriseColor"
          dark
          fab
          x-small
          elevation="1"
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-menu
          </v-icon>
        </v-btn>
      </template>
      <v-btn
        v-for="(item, index) in menu"
        :key="`mnu${index}`"
        fab
        dark
        small
        :color="enterpriseColor"
        :disabled="!item.admin && !enterpriseID"
        style="z-index:100;"
        @click="handleGoTo(item.rute)"
      >
      <v-icon>{{item.icon}}</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-navigation-drawer
      v-else
      permanent
      fixed
      dark
      mini-variant
      mini-variant-width="56"
      :color="enterpriseColor"
      app
    >
      <template v-slot:prepend>
        <v-list>
          <v-list-item
            @click="handleGoTo('/dashboard')"
          >
            <v-list-item-avatar
              tile
            >
              <v-img :src="require('@/assets/logo.png')"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="title">DTouch</v-list-item-title>
            </v-list-item-content>
            <!-- <v-list-item-action>
              <v-icon>mdi-menu-down</v-icon>
            </v-list-item-action> -->
          </v-list-item>
        </v-list>
      </template>

      <v-divider></v-divider>
      <v-list
        nav
        dense
      >
        <v-list-item
        bottom
          v-for="(item, index) in menu"
          :key="`mnu${index}`"
          :class="item.admin ? 'admin' : 'normal'"
          :disabled="!item.admin && !enterpriseID"
          link
          @click="handleGoTo(item.rute)"
        >
          <!-- <v-list-item-icon>
            <v-icon :class="item.admin ? 'admin' : 'normal'">{{ item.icon }}</v-icon>
          </v-list-item-icon> -->
          <v-list-item-icon>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon :class="item.admin ? 'admin' : 'normal'" v-on="on">{{ item.icon }}</v-icon>
              </template>
              <span>{{ $t(item.title) }}</span>
            </v-tooltip>
          </v-list-item-icon>
          <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                block
                text
                @click="handleGoTo('/share')"
              >
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('share.title') }}</span>
          </v-tooltip>
        </div>
      </template>
    </v-navigation-drawer>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import api from '@/services/api'
  import utils from '@/services/utils'
  export default {
    data: () => ({
      menu: constants.menus.filter(x => !x.admin),
      color: 'red',
      fab: null,
    }),
    computed: {
      ...mapState('app',['userName','enterpriseColor','enterpriseID']),
      isMobile () {
        return utils.isMobile() || this.$route.query.fm === 'true' || this.$route.query.onlyContent
      },
    },
    watch: {
      userName: {
        handler () {
          this.getMenus()
        },
        deep: true
      }
    },
    mounted () {
      this.getMenus()      
    },
    methods: {
      getMenus () {
        api.getItem('users', true, utils.getUserID()).then(response => {
          // Para evitar que en los menús comunes se muestre una personalización 
          // de una empresa ajena al usuario revisamos la empresa
          // si es un administrador ignoramos esto
          if (response.Role !== constants.roles.admin && response.Enterprises.indexOf(this.enterpriseID) === -1) {
            this.$store.state.app.enterpriseID = response.EnterpriseDefault
          }

          this.menus = []
          if (response.Role === constants.roles.admin) this.menu = constants.menus 

          const commonMenuItem = {
            icon: 'mdi-menu',
            title: 'commonMenus.title',
            rute: '/common-menus',
            admin: false
          }
          
          if (response.Permission.indexOf(7) !== -1 && this.menu.filter(x => x.rute === commonMenuItem.rute).length === 0) {
            this.menu.push(commonMenuItem)
          }       
          const customizationItem = {
            icon: 'mdi-cellphone-settings',
            title: 'settings.title',
            rute: '/settings',
            activeEnterprise: true
          }
          if (response.HideCustomization !== 1 && this.menu.filter(x => x.rute === customizationItem.rute).length === 0) {
            this.menu.push(customizationItem)
          }
          const settingsItem = {
            icon: 'mdi-cellphone-cog',
            title: 'menus.title',
            rute: '/menus',
            activeEnterprise: true
          }
          this.$store.state.app.hideSettings = response.HideSettings === 1 ? true : false
          if (response.HideSettings !== 1 && this.menu.filter(x => x.rute === settingsItem.rute).length === 0) {
            this.menu.push(settingsItem)
          }
          const disheItem = {
            icon: 'mdi-food-fork-drink',
            title: 'dishes.title',
            rute: '/dishes',
            activeEnterprise: true
          }
          if (response.DishesMenu && this.menu.filter(x => x.rute === disheItem.rute).length === 0) {
            this.menu.push(disheItem)
          }

          const rcovidItem = {
            icon: 'mdi-virus',
            title: 'rcovid.title',
            rute: '/fcovid',
            activeEnterprise: true
          }
          if (response.RCovidMenu && this.menu.filter(x => x.rute === rcovidItem.rute).length === 0) {
            this.menu.push(rcovidItem)
          }

          const rFormCioItem = {
            icon: 'mdi-format-list-text',
            title: 'formCio.title',
            rute: '/custom-forms',
            activeEnterprise: true
          }
          if (response.RFormCio && this.menu.filter(x => x.rute === rFormCioItem.rute).length === 0) {
            this.menu.push(rFormCioItem)
          }

          const productItem = {
            icon: 'mdi-decagram',
            title: 'menuType.productService',
            rute: '/products',
            activeEnterprise: true
          }
          if (response.Permission.indexOf(8) !== -1 && this.menu.filter(x => x.rute === productItem.rute).length === 0) {
            this.menu.push(productItem)
          }

          const pollItem = {
            icon: 'mdi-poll',
            title: 'menuType.poll',
            rute: '/poll',
            activeEnterprise: true
          }
          if (response.Permission.indexOf(9) !== -1 && this.menu.filter(x => x.rute === pollItem.rute).length === 0) {
            this.menu.push(pollItem)
          }

          const dishOrdersItem = {
            icon: 'mdi-invoice-text-check-outline',
            title: 'dishOrders.title',
            rute: '/dish-orders',
            activeEnterprise: true
          }
          if (response.Permission.indexOf(10) !== -1 && this.menu.filter(x => x.rute === dishOrdersItem.rute).length === 0) {
            this.menu.push(dishOrdersItem)
          }
          
          const welcomeFormItem = {
            icon: 'mdi-form-select',
            title: 'welcomeForm.title',
            rute: '/welcome-form',
            activeEnterprise: true
          }
          if (response.Permission.indexOf(11) !== -1 && this.menu.filter(x => x.rute === welcomeFormItem.rute).length === 0) {
            this.menu.push(welcomeFormItem)
          }
        })
      },
      handleGoTo (rute) {
        // if (rute === '/common-menus') {   
        //   const id = '72c0948f-7eef-4d82-ab84-f94862c7a37f'       
        //   api.getItem('enterprises', true, id).then(response => {
        //     utils.setActiveEnterprise(this, response)
        //     this.$router.push(rute)
        //   })
        // } else {
          this.$router.push(rute)
        // }
      }
    }
  }
</script>

<style lang="scss">
  .admin {
    color: red !important;
  }
  .normal {
    color: white !important;
  }
  .v-list-item--disabled {
    opacity: 0.1;
  }
  .v-navigation-drawer__content::-webkit-scrollbar {
    display: none;
  }
  .v-navigation-drawer__content {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
</style>
